module.exports = __webpack_public_path__ + "img/ctrl-givens-stub--.44f3696c.svg";